import React, { Component } from 'react'
import { selectors, actions } from './sagas/reservation';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import './stylesheets/Cheers.sass'

export default class BadPermission extends Component {
  render () {
    return (
    <div className={'cheers-page'}>
      <div className={'cheers-wrapper'}>
        <img alt='Cheers!' src={'Cheers.png'} />
        <div className={'cheers'}>
          We like your enthusiasm!
        </div>
        <div className={'complete'}>
          But it doesn't look like you have permission to view this page.
        </div>
        <div className={'confirmation-email'}>
          If you think this is an error. Give us a call at (970) 946-5380
        </div>
        { this.props.history &&
        <div>
          <button onClick={ () => this.props.history.go(-2) } className={'return-button'}>
              Go Back
            </button>
        </div>
        }
      </div>

    </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/BadPermissions.jsx